export default "__VITE_ASSET__18ac1f75__"